import { useEffect, useState } from 'react';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';

import {
	TableData,
	TabStatus,
	AttendantsResponse, User
} from './BackofficeLNLMAttendants.model';
import useObjectHelper from "../../Helpers/useObjectHelper";

export const pageSize = 10;

const useLNLMAttendants = () => {
	const [ attendants, setAttendants ] = useState<TableData[]>([]);
	const [ pagination, setPagination ] = useState({ page: 1, size: pageSize, total: 0 });
	const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);
	const [ exportPopup, setExportPopup] = useState<boolean>(false);
	const [importPopup, setImportPopup] = useState<boolean>(false);
	const [csvFile, setCsvFile] = useState<any>(null);
	const { objToFormData } = useObjectHelper();

	const { get, postFormData } = useFetchWrapper();

	useEffect(() => {
		getUsers();
	}, [pagination.page]);
	
	useEffect(() => {
		if(csvFile) {
			onImportCsvFile();
		}
	}, [csvFile]);

	const toggleExportPopup = () => {
		setExportPopup(prevState => !prevState);
	}
	
	const toggleImportPopup = () => {
		setImportPopup((prevState) => !prevState);
	};
	
	const onImportCsvFile = async () => {
		const body = {
			csv: csvFile
		};
		const response = await postFormData(`/user/potential/import`, objToFormData(body))
		if (response.status === 201) {
			toggleImportPopup();
			await getUsers();
		}
	};
	
	const onExportAttendants = async () => {
		const response = await get('/user/potential/export');
		if (response.status === 200) toggleExportPopup();
	};
	
	const getUsers = async () => {

		setTabStatus(TabStatus.Loading);

		const res: HttpResponse<AttendantsResponse> = await get(`/user/potential/all?page=${pagination.page}&size=${pagination.size}`);
		
		if (res.parsedBody) {
			const { count, users } = res.parsedBody;
				setAttendants(users.map((item: User, index: number) => ({
					conference: item.lnLong,
					email: item.email,
					key: `${index}`,
					name: `${item.firstName} ${item.lastName}`,
					secondaryEmail: item.secondaryEmail,
				})));

			setPagination({
				...pagination,
				total: count,
			});
			setTabStatus(TabStatus.Loaded);
		} else {
			setTabStatus(TabStatus.Error);
		}
	};

	const onChangeUsersPagination = (page: number) => {
		setPagination({ ...pagination, page, });
	};


	return {
		getUsers,
		onChangeUsersPagination,
		onExportAttendants,
		setCsvFile,
		state: {
			attendants,
			csvFile,
			exportPopup,
			importPopup,
			pagination,
			tabStatus,
		},
		toggleExportPopup,
		toggleImportPopup
	};
}

export default useLNLMAttendants;